import type { Game } from '../../game/Game';
import { registerPanel } from '../../ui/app/App';
import { setGame } from '../economy/ui';
import './travel.css';
import { WaystonePanel } from './WaystonePanel';

export { travelToWaystone } from './WaystonePanel';
export { travelCost, waystonesIn } from './waystones';
export { allWaystones } from './world';

/** Waystone fast travel (`waystone` panel). */
export function install(game: Game): void {
  setGame(game);
  registerPanel('waystone', WaystonePanel);
}
